import { config_settings } from '@/config.js';
import Vue from 'vue';

const baseApiUrl = config_settings.RESOURCE_SERVER_URL;

export const getMultimediaInfo = () => {
  return Vue.$http.get(baseApiUrl + '/GET/multimedia');
};
